"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const nanoid_1 = require("nanoid");
const defaultBackgroundElement_1 = __importDefault(require("./defaultBackgroundElement"));
function defaultScene(active = true) {
    return {
        id: (0, nanoid_1.nanoid)(8),
        active,
        duration: 5,
        elements: [(0, defaultBackgroundElement_1.default)()],
        sceneId: null,
        isTemplate: false,
        voiceOver: null,
    };
}
exports.default = defaultScene;
